import { useIntl, getLocale } from 'umi';
import useMarketFilterApi, {
  MarketSpecailType,
} from '@/pages/intelligence/hooks/useMarketSelector';
import { useEffect, useState } from 'react';
import { LANGUAGE_CN, LANGUAGE_EN } from '@/pages/home/_config/config';

interface Country {
  code: string;
  nameEn: string;
  nameCh: string;
}

export default function useCountriesNames() {
  const locale = getLocale();

  const { regionOptions } = useMarketFilterApi({
    filterType: MarketSpecailType.rpd,
  });
  const [countries, setCountries] = useState<Country[]>([]);

  useEffect(() => {
    const countries: Country[] = [];
    countries.push(
      {
        code: 'global',
        nameEn: 'Global',
        nameCh: '全球',
      },
      {
        code: 'global_wo_china',
        nameEn: 'Global except China mainland',
        nameCh: '全球（不包括中国大陆）',
      },
    );
    if (!Array.isArray(regionOptions)) {
      return;
    }
    // 遍历处理每个地区，并将国家数据添加到相应的国家集合中
    regionOptions?.forEach((area: any) => {
      countries.push({
        code: area.area_code,
        nameEn: area.area_name_en,
        nameCh: area.area_name_ch,
      });

      area.country_set.forEach((country: any) => {
        countries.push({
          code: country.country_code,
          nameEn: country.country_name_en,
          nameCh: country.country_name_ch,
        });
      });
    });
    setCountries(countries);
  }, [JSON.stringify(regionOptions)]);

  /**获取国家对象，也可能是undefine
   * 参数：传简称或英文全称或中文全称
   * 返回{
      code: 简称,
      nameEn: 英文全称,
      nameCh: 中文全称,
    } 
  */
  const findCountryObj = (name: string): Country | void => {
    const area = countries.find((item: Country) =>
      [item.code, item.nameEn, item.nameCh].includes(name),
    );

    return area;
  };

  /**传简称或英文全称或中文全称， 根据语言状态返回中文全称或英文全称  */
  const findCountryLocalName = (name: string): string => {
    const area = findCountryObj(name);

    return (locale === LANGUAGE_CN ? area?.nameCh : area?.nameEn) ?? name;
  };

  return { countries, findCountryObj, findCountryLocalName };
}
